import React from 'react';
import type { Hero } from 'types';

import { Heading, RichText } from '@leafwell/components';

const HeroResearch: React.FC<{ hero?: Hero }> = ({
  hero: { subTitle, title, description },
}) => (
  <>
    <Heading level="6" className="lg:col-span-full">
      {subTitle}
    </Heading>
    <Heading className="lg:col-span-4">{title}</Heading>
    <RichText
      content={description}
      className="leading-relaxed lg:col-span-5 xl:pt-5"
    />
  </>
);

export default HeroResearch;
